import '@updater-components/icon';
import { throttle } from 'lodash-es';
import { track, DISPLAY } from '@updater-core/lib/tracker';
import {
  DASHBOARD_LABEL,
  DASHBOARD_STATE,
} from './new-product-intro.constants';
import { productIntroCards } from '../../state/contentful/entries.json';
import './carousel';
import { actions } from '../../state';
import {
  mapStateToThis,
  resetReducer,
  enterCardReducer,
  leaveCardReducer,
  leaveContainerReducer,
} from './new-product-intro.utils';
import { mount } from './new-product-intro.mount';

export class NewProductIntroController {
  constructor($element, updStore) {
    'ngInject';
    Object.assign(this, { $element, updStore, rendered: false });
  }

  $onInit() {
    this.updStore.dispatch(actions.contentful.contentfulGet(productIntroCards));

    const reset = this.reset;
    this.reset = () =>
      // NOTE: This timeout is to prevent rendering issues in Firefox and IE.
      // There is a timing issue somewhere that we haven't been able to pin down.
      setTimeout(() => {
        reset.bind(this)();
      });

    Object.assign(this, {
      dashboardLink: {
        label: DASHBOARD_LABEL,
      },
    });

    this._handleResize = throttle(function () {
      if (this.prevWindowWidth === window.innerWidth) return;
      this.prevWindowWidth = window.innerWidth;
      this.reset();
    }, 200).bind(this);
    window.addEventListener('resize', this._handleResize);
  }

  $postLink() {
    this.view = this.$element[0];
    this.unsubscribe = this.updStore.subscribe(this.reset);
  }

  $onDestroy() {
    window.removeEventListener('resize', this._handleResize);
    this.unsubscribe();
  }

  reset() {
    const { cards, origCards } = mapStateToThis(
      this.updStore.getState(),
      this.useAlternateWeight === 'true'
    );

    this.cards = cards;
    this.origCards = origCards;

    // syi content A/B test
    const trackAndRender = () => {
      if (!this.trackedDisplayedEvent && this.cards && this.cards.length > 0) {
        this.trackedDisplayedEvent = true;
        const action = actions.analytics.track(
          `Displayed Product Intro Cards`,
          {
            steps: this.cards.map((card) => card.title),
            experience: 'carousel',
          }
        );
        this.updStore.dispatch(action);
      }

      Object.assign(
        this,
        resetReducer(
          {
            cards: this.cards,
          },
          window.innerWidth
        )
      );

      this.render();
    };
    trackAndRender();
  }

  handleCarouselChange({ detail: { index } }) {
    Object.assign(this, enterCardReducer(this, index));
    this.render();
  }

  handleEnterCard(index) {
    Object.assign(this, enterCardReducer(this, index));
    this.render();
  }

  handleLeaveCard() {
    Object.assign(this, leaveCardReducer(this));
    this.render();
  }

  handleContainerLeave() {
    Object.assign(this, leaveContainerReducer(this));
    this.render();
  }

  handleCardClick(index) {
    const title = this.cards[index].title;
    const state = this.cards[index].cta.state;
    this.updStore.dispatch(actions.analytics.track(`Clicked ${title} Button`));
    this.updStore.dispatch(actions.router.stateGo(state));
  }

  handleDashboardClick() {
    this.updStore.dispatch(
      actions.analytics.track(`Clicked See My Customized Dashboard Link`)
    );
    this.updStore.dispatch(actions.router.stateGo(DASHBOARD_STATE));
  }

  render() {
    mount(this.view, this);

    if (!this.rendered) {
      track({
        object: 'product_intro',
        verb: DISPLAY,
      });
      this.rendered = true;
    }
  }
}

export const NewProductIntroComponent = {
  template: '',
  controller: NewProductIntroController,
  bindings: {
    useAlternateWeight: '@',
    title: '=',
    subtitle: '=',
  },
};
